import enums from '@/plugins/enums.js'
import { ersSteps } from '@/apps/ERS/routes.js'

// TODO: FIXME old config for future improvements
function canDownloadReport(row) {
  return row.can?.download_report
}

export const getLegacyActionButtons = function () {
  const valuationActions = [
    {
      label: this.row.valuation_type === 'dvm' ? this.row.payment_summary?.status : 'appointment',
      color: 'main',
      icon: 'mdi-eye',
      show:
        this.row.borrower?.is_self &&
        this.row.valuation_type !== 'ers' &&
        this.row.status === enums.requestStatus.SUBMITTED,
      to: {
        name: 'valuation.borrower',
        query: {
          valuation_request_ref: this.row.valuation_request_ref,
        },
      },
    },
    // We'll keep the old valuer tool around until the new one is feature complete
    {
      label: 'dvm',
      color: 'main',
      icon: 'mdi-eye',
      show:
        this.hasRole('valuer', 'dvm') &&
        this.row.valuation_type === 'dvm' &&
        this.row.payment_summary?.is_payment_completed &&
        // this.isAssignedValuer &&
        [
          enums.requestStatus.SUBMITTED,
          enums.requestStatus.VALUED,
          enums.requestStatus.AWAITING_ONSITE,
          enums.requestStatus.OUT_OF_SCOPE,
        ].includes(this.row.status),
      to: {
        name: `valuation.valuer-app.general`,
        query: {
          valuation_request_ref: this.row.valuation_request_ref,
        },
      },
    },
    {
      label: 'dvm_legacy_tool',
      color: 'main',
      show:
        this.hasRole('valuer', 'dvm') &&
        this.row.valuation_type === 'dvm' &&
        this.row.payment_summary?.is_payment_completed &&
        // this.isAssignedValuer &&
        [
          enums.requestStatus.SUBMITTED,
          enums.requestStatus.VALUED,
          enums.requestStatus.AWAITING_ONSITE,
          enums.requestStatus.OUT_OF_SCOPE,
        ].includes(this.row.status),

      to: {
        name: 'valuation.dvm',
        query: {
          valuation_request_ref: this.row.valuation_request_ref,
        },
      },
    },
    {
      label: 'unvalue',
      color: enums.feedbackType.NEGATIVE,
      icon: 'mdi-undo',
      loading: this.requestMutation.isBusy,
      show: this.row.can.unsubmit_valuation,
      click: () => this.unsubmitVal(),
    },
    {
      label: 'take_ownership',
      color: enums.feedbackType.WARNING,
      icon: 'mdi-account-convert',
      show: this.showOwnershipButton,
      loading: this.requestMutation.isBusy,
      click: () => (this.isOwnershipDialogOpen = true),
    },
  ]

  const ersActions = [
    {
      label: 'edit',
      color: 'main',
      icon: 'mdi-pencil',
      loading: this.ersEditLoading,
      show:
        (this.row.status === enums.requestStatus.DRAFT || this.row.status === enums.requestStatus.FAILED) &&
        (this.isOwner || this.row.borrower?.is_self),
      click: () => this.ers_edit_draft(this.row.valuation_request_ref),
    },
    {
      label: 'web_ers_report',
      color: 'main',
      icon: 'mdi-file-document-outline',
      show:
        (this.row.status === enums.requestStatus.VALUED) &
        (this.isOwner ||
          this.hasRole(['reporter', 'dispatcher'], this.row.valuation_type) ||
          this.row.borrower?.is_self),
      to: {
        name: 'ers.request',
        params: {
          action: ersSteps.RESULT,
        },
        query: { valuation_request_ref: this.row.valuation_request_ref },
      },
    },
    {
      label: 'view_request',
      color: 'main',
      icon: 'mdi-eye',
      show: this.row.status !== enums.requestStatus.DRAFT,
      to: {
        name: 'ers.request',
        params: {
          action: ersSteps.SUBMIT_SUMMARY,
        },
        query: { valuation_request_ref: this.row.valuation_request_ref },
      },
    },
    {
      label: 'take_ownership',
      color: enums.feedbackType.WARNING,
      icon: 'mdi-account-convert',
      show:
        this.showOwnershipButton &&
        ([enums.requestStatus.SUBMITTED, enums.requestStatus.VALUED].includes(this.row.status) ||
          this.row.owner),
      loading: this.requestMutation.isBusy,
      click: () => this.requestMutation.updateOwner(),
    },
  ]

  const oepcActions = [
    {
      label: 'epc_report',
      color: 'main',
      show: canDownloadReport(this.row) && this.showReport('pdf') && this.row.report_ref,
      click: () => this.report.download(),
    },
    {
      label: 'appointment',
      color: 'main',
      show: this.row.status === enums.requestStatus.SUBMITTED && this.row.borrower?.is_self,
      to: {
        name: 'oepc.request',
        query: { valuation_request_ref: this.row.valuation_request_ref },
      },
    },

    {
      label: 'edit',
      color: 'main',
      icon: 'mdi-pencil',
      show:
        (this.row.status === enums.requestStatus.DRAFT || this.row.status === enums.requestStatus.FAILED) &&
        (this.isOwner || this.row.borrower?.is_self),
      to: {
        name: 'oepc.request',
        query: { valuation_request_ref: this.row.valuation_request_ref },
      },
    },
  ]

  const catActions = [
    {
      label: 'assistant',
      color: 'main',
      icon: 'mdi-eye',
      show: true,
      to: {
        name: 'knowledge-base-assistant',
        query: {
          valuation_request_ref: this.row.valuation_request_ref,
        },
      },
    },
    {
      label: 'view_property',
      color: 'main',
      icon: 'mdi-eye',
      show: true,
      to: {
        name: 'catalog-view',
        query: {
          request_ref: this.row.valuation_request_ref,
        },
      },
    },
  ]

  return [
    ...(this.row.valuation_type === 'ers' ? ersActions : []),
    ...(this.row.valuation_type === 'oepc' ? oepcActions : []),
    ...(this.row.valuation_type === 'cat' ? catActions : []),
    ...(['avm', 'dvm', 'ovm'].includes(this.row.valuation_type) ? valuationActions : []),
  ]
}
